import styled from 'styled-components';
import { PREVIEW_FORMATS, PreviewFormat } from '@agency-smm/shared';

const FormatSelect = styled.select`
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
  border: ${({ theme }) => theme.borders.thin};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  color: ${({ theme }) => theme.colors.text};
  background-color: ${({ theme }) => theme.colors.surface};
  cursor: pointer;
  min-width: 140px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.surfaceHover};
    cursor: not-allowed;
  }
`;

interface FormatSelectorProps {
  value: PreviewFormat;
  onChange: (format: PreviewFormat) => void;
  className?: string;
  disabled?: boolean;
}

export function FormatSelector({ value, onChange, className, disabled }: FormatSelectorProps) {
  return (
    <FormatSelect
      value={value}
      onChange={(e) => onChange(e.target.value as PreviewFormat)}
      className={className}
      disabled={disabled}
    >
      {Object.entries(PREVIEW_FORMATS).map(([key, format]) => (
        <option key={key} value={key}>
          {format.label}
        </option>
      ))}
    </FormatSelect>
  );
}
